<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {}
  },
  mounted() {
    if (sessionStorage.getItem('tokenExpired')) {
      sessionStorage.removeItem('tokenExpired')
    }
  }
}
</script>

<style lang="scss">
@import './assets/style/common.scss';
* {
  margin: 0;
  padding: 0;
}
body {
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.el-message {
  min-width: 80px !important; /* 设置最小宽度为200px，根据需要调整 */
}
</style>
